import request from "utils/request";

import { baseRequestURL, constructQueryParams } from "api/BaseAPI";

export function getHelpUri() {
  // TODO: set service back to zendesk if we don't have this working in time for release
  return request(baseRequestURL + "v1/ssoRedirect?service=aibledocs", {
    method: "GET"
  }).then((response) => response);
}
